import { functions } from "../firebase/firebase.config";

export async function _callCloudFunction(
  functionName: string,
  params: any = {}
) {
  const response = await functions(functionName)(params);
  return response.data;
}
